import * as yup from "yup";
import {
  CONDITIONS,
  GENDER,
  MARTIAL_STATUSES,
  POPULATION_FOCUSES,
  RACES,
} from "./common";
export const US_PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/; // US phone_number pattern
const US_ZIP_CODE_REGEX = /^[0-9]{5}(-[0-9]{4})?$/; // US ZIP code (5 digits)
export const US_STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];
export const formatPhoneNumber = (value, previousValue = 0) => {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7)
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  }
};
export const isValidPhoneNumber = (phoneNumber) =>
  US_PHONE_REGEX.test(phoneNumber);

export const memberSchema = yup.object().shape({
  // Personal Info
  // name: yup.string().required("Name is required"),
  first_name: yup.string().required("First Name is required"),
  last_name: yup.string().required("Last Name is required"),
  date_of_birth: yup.date().required("Date of Birth is required"),
  gender: yup.string().required("Gender is required"),

  // Membership Info
  cin: yup.string().required("CIN is required"),
  aica_account: yup.string(),
  // subscriber_id: yup.string(),
  health_plan_id: yup.string().required("Health Plan is required"),
  if_number: yup.number(),

  // Contact Info

  // home_city: yup.string().required("Home City is required"),
  // home_state: yup
  //   .string()
  //   .oneOf(US_STATES, "Invalid US state abbreviation")
  //   .required("State is required"),
  // home_zip: yup
  //   .string()
  //   .matches(US_ZIP_CODE_REGEX, "ZIP Code must be 5 digits")
  //   .required("Home ZIP Code is required"),
  phone_number: yup
    .string()
    .matches(US_PHONE_REGEX, "Phone number is not valid *")
    .required("Phone Required")
    .nullable(),
  email: yup.string().email(),
  // location: yup.string().required(),
  home_address: yup.string().required("Home Address is required"),

  state_id: yup.mixed().required("Home State is required"),

  // .oneOf(US_STATES, "Invalid US state abbreviation")
  county_id: yup.mixed().required("Home County is required"),

  // .matches(US_ZIP_CODE_REGEX, "Home ZIP Code must be 5 digits")
  city_id: yup.mixed(),
  zip_code_id: yup.mixed(),

  mailing_address: yup.string().required("Mailing Address is required"),
  mailing_state_id: yup.mixed().required("Mailing State is required"),

  // .oneOf(US_STATES, "Invalid US state abbreviation")
  mailing_county_id: yup.mixed().required("Mailing County is required"),

  // .matches(US_ZIP_CODE_REGEX, "Mailing ZIP Code must be 5 digits")
  mailing_zip_code_id: yup.mixed(),

  // Communication Preferences
  preferred_spoken_lang: yup
    .string()
    .required("Preferred Spoken Language is required"),
  preferred_written_lang: yup
    .string()
    .required("Preferred Written Language is required"),

  // Other
  population_focus: yup
    .array()
    .min(1, "Population of Focus is required")
    .required("Population of Focus is required"),

  conditions: yup
    .array()
    .min(1, "Condition is required")
    .required("Condition is required"),
});

export const memberInitialValues = (selectedMember) => {
  if (selectedMember) {
    const homeAddress = selectedMember?.addresses?.find(
      (addr) => addr.address_type === "home"
    );
    const mailingAddress = selectedMember?.addresses?.find(
      (addr) => addr.address_type === "mailing"
    );

    const initialValues = {
      name: selectedMember?.name || "",
      first_name: selectedMember?.first_name || "",
      last_name: selectedMember?.last_name || "",
      date_of_birth: selectedMember?.date_of_birth || "",
      gender: selectedMember?.gender,

      ehtnicity: selectedMember?.ehtnicity || "",
      martial_status: selectedMember?.martial_status || "",

      // Membership Info
      cin: selectedMember?.cin || "",
      aica_account: selectedMember?.aica_account || "",
      // subscriber_id: selectedMember?.subscriber_id || "",
      health_plan_id: selectedMember?.health_plan?.id || "",
      if_number: selectedMember?.if_number || "",

      // Contact Info

      home_address: homeAddress?.street || "",
      // home_city: homeAddress?.city || "",
      // home_state: homeAddress?.state || "",
      // home_zip: homeAddress?.zip_code || "",
      // mailing_city: mailingAddress?.city || "",
      // mailing_state: mailingAddress?.state || "",
      // mailing_zip: mailingAddress?.zip_code || "",
      phone_number: selectedMember?.phone_number || "",
      email: selectedMember?.email || "",
      mailing_address: mailingAddress?.street || "",
      state_id: {
        value: selectedMember?.state?.id || "",
        label: selectedMember?.state?.name || "",
      },
      city_id: {
        value: selectedMember?.city?.id || "",
        label: selectedMember?.city?.name || "",
      },
      county_id: {
        value: selectedMember?.county?.id || "",
        label: selectedMember?.county?.name || "",
      },
      zip_code_id: {
        value: selectedMember?.zip_code?.id || "",
        label: selectedMember?.zip_code?.code || "",
      },
      mailing_state_id: {
        value: mailingAddress?.state_id || "",
        label: mailingAddress?.state || "",
      },
      mailing_city_id: {
        value: mailingAddress?.city_id || "",
        label: mailingAddress?.city || "",
      },
      mailing_county_id: {
        value: mailingAddress?.county_id || "",
        label: mailingAddress?.county || "",
      },
      mailing_zip_code_id: {
        value: mailingAddress?.zip_code_id,
        label: mailingAddress?.zip_code || "",
      },

      // Communication Preferences
      preferred_spoken_lang: selectedMember?.preferred_spoken_lang || "",
      preferred_written_lang: selectedMember?.preferred_written_lang || "",

      // Other
      population_focus:
        POPULATION_FOCUSES.filter((c) =>
          selectedMember?.population_focus
            ?.split(",")
            .map((item) => item.trim())
            .includes(c.value)
        ) || [],
      conditions:
        CONDITIONS.filter((c) =>
          selectedMember?.conditions
            ?.split(",")
            .map((s) => s.trim())
            .includes(c.value)
        ) || [],

      //Authorizations information
      auth_program: selectedMember?.auth_program || "ECM",
      auth_number: selectedMember?.auth_number || "",
      auth_start_date: selectedMember?.auth_start_date || "",
      auth_end_date: selectedMember?.auth_end_date || "",
    };
    return initialValues;
  }

  return {
    // Personal Info
    name: "",
    first_name: "",
    last_name: "",
    date_of_birth: "",
    gender: "",
    ehtnicity: "",
    martial_status: "",

    // Membership Info
    cin: "",
    aica_account: "",
    // subscriber_id: "",
    health_plan_id: "",
    if_number: "",

    // Contact Info
    // home_city: "",
    // home_state: "",
    // home_zip: "",
    // mailing_city: "",
    // mailing_state: "",
    // mailing_zip: "",
    phone_number: "",
    email: "",
    home_address: "",
    mailing_address: "",
    state_id: "",
    city_id: "",
    county_id: "",
    zip_code_id: "",
    mailing_state_id: "",
    mailing_city_id: "",
    mailing_county_id: "",
    mailing_zip_code_id: "",
    // Communication Preferences
    preferred_spoken_lang: "",
    preferred_written_lang: "",

    // Other
    population_focus: [],
    conditions: [],

    //Authorizations information
    auth_program: "ECM",
    auth_number: "",
    authstart_date: "",
    auth_end_date: "",
  };
};
